import { motion } from 'motion/react';
import CategoriesSelector from '../../../Categories';
import styles from './Categories.module.css';

const Categories = (_) => {
    return (
        <div  className={styles.container}>
            <motion.div
                className={styles.content}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
            >
                <CategoriesSelector reference="details" />
            </motion.div>
        </div>
    );
};

export default Categories;
